import * as React from 'react';
import { useEffect, useMemo } from 'react';
import CheckOutButtons from './CheckOutButtons';
import Step1 from './Step1';
import HotelsRecommendations from './HotelsRecommendations';
import { CheckoutContext, Steps } from './utils/CheckoutContext';
import MoreVenues from './MoreVenues/MoreVenues';
import StepperWrapper from './StepperWrapper';
import { useHistory } from 'react-router';
import { FeatureFlagContext, FLAG_SHOPPING_CART_FOR_SRP } from '@weddingspot/ws-core-components';
import Final from './Final';

const styles = require('./CheckOutPage.module.scss');

const { Wizard } = require('@cvent/carina-wizard');

const CheckOutPage = () => {
    const { step } = React.useContext(CheckoutContext);
    const history = useHistory();
    const { flagEnabled, isInitialized } = React.useContext(FeatureFlagContext);

    if (!flagEnabled(FLAG_SHOPPING_CART_FOR_SRP) && isInitialized) {
        history.push('/wedding-venues');
    }

    return (
        <section className={styles.CheckOut}>
            <Wizard initialStep='1' initialSteps={['1', '2', '3', '4']}>
                <StepperWrapper />
                <div className={styles.body}>
                    {step === Steps.FirstStep && <Step1 />}
                    {step === Steps.MoreVenues && <MoreVenues />}
                    {step === Steps.HotelsRecommendations && <HotelsRecommendations />}
                    {step === Steps.Final && <Final />}
                </div>
                <CheckOutButtons />
            </Wizard>
        </section>
    );
};

export default CheckOutPage;
